var _image;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "auidio",
    width: 13,
    height: 25,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAZCAYAAADqrKTxAAABbElEQVQ4jc3TsUuWURQG8N/3qYgOQkNLoGlbkwRRQZMugdCgWAQtDYJjo6v4B4QELTmILaUOiWNTgbnoIEhLIBQRkU1iipimXDmvXF/18xt94OVyuOe555znfU7l9a01Z6CCBvyP7wSqpTgljuNffPuYRmst0iieB7nAY7ysRWrEFDYj3sObqHicW57p4KwBA134VrycYyqCPlyNCu+i4t+8nRydETRnldvjbLyI1JLdd15E+hhnP5qivU/xr3ZyIe7iNl7VIcS9pGKS8Q6GaiTneIKBQvtKnaSj3Gr0Xah1ymcZtkODvUTaQEcMvnoO4SfWcRO/E+lrGHIQI+dUG8N93MBSIq3gO17gC3pD5l9YwCPMYCI8OV+NFXiKK1iOVh/gGnrifjlaG07jFOp9jgpb4eqNMGc659CWpMZbpdVYjNfS/nzA9ajwLKz0vkgs22gXs/iDh5jMnH+M8hLWhUtOKgtRYAnd+HHqBoeAvlGO1+evbgAAAABJRU5ErkJggg=="
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAudio);
export default __webpack_public_path__ + "static/media/ico_audio.c6ac3bf7.svg";
export { ForwardRef as ReactComponent };